import { IUser } from "./types";
import venchy from "../images/avatar_venchy.png";
import { TQuestion } from "../services/types";
import { Dispatch, SetStateAction } from "react";

export const getTimeFromTimestamp = (
  date: string | Date | undefined | null
): string => {
  if (!date) {
    return "";
  }

  const dateString =
    typeof date === "string" ? date : formatDateTimeInIsrael(date);

  if (dateString && dateString.includes("T")) {
    const timestampParts = dateString.split("T");

    if (timestampParts.length > 1 && timestampParts[1]) {
      return timestampParts[1].slice(0, 5);
    }
  }

  return "";
};

export const venchyData: IUser = {
  id: "venchy",
  name: "וונצ’י",
  avatar: venchy,
};

export const israeliPhoneRegExp =
  /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))(?:\s|\.|-)?([1-9]\d?))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?([^0\D]{1}\d{2}(?:\s|\.|-)?\d{4})$/;

// E.164-like international validation: optional '+', 6-15 digits total
// Allows spaces, dashes, and parentheses which are stripped before validation
export function isValidInternationalPhone(rawPhone: string): boolean {
  if (!rawPhone) return false;
  const normalized = rawPhone.replace(/[\s()-]/g, "");
  if (!/^\+?\d+$/.test(normalized)) return false;
  const digits = normalized.startsWith("+") ? normalized.slice(1) : normalized;
  return digits.length >= 6 && digits.length <= 15;
}

export const BPREVEN_CLIENT_URL = "https://client.bpreven.com";
export const BPREVEN_CLIENT_TEST_URL = "https://client-test.bpreven.com";

export const BASE_URL = "https://api-test.bpreven.com/";
export const prevencherId = "prevencherId";
export const mobileWidth = "(max-width: 600px)";
export const TYPING_CODE = "TYPING_CODE";
export const END_CALL_CODE = "END_CALL_CODE";

export function getPrintDate(date: Date): string {
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}

export const getTermsArrayGeneral = () => [
  {
    id: 1,
    title: "הגדרה",
    text: "TERMS_INTRO",
  },
  {
    id: 2,
    title: "שירותים",
    text: "TERMS_SUPPORT_ASSOCIATION",
  },
  {
    id: 3,
    title: "אחריות",
    text: "TERMS_LIABILITY",
  },
  {
    id: 4,
    title: "תנאי שימוש",
    text: "TERMS_USAGE",
  },
  {
    id: 5,
    title: "הסכמים נוספים",
    text: "TERMS_OTHER_AGREEMENTS",
  },
  {
    id: 6,
    title: "הסכמה",
    text: "TERMS_CONSENT",
  },
  {
    id: 7,
    title: "הוראות צד ג",
    text: "TERMS_THIRD_PARTY",
  },
  {
    id: 8,
    title: "נוסח הסכם",
    text: "TERMS_FORMAT",
  },
  {
    id: 9,
    title: "סליקת אשראי",
    text: "TERMS_PAYMENT",
  },
  {
    id: 10,
    title: "אחריות משתמש",
    text: "TERMS_USER_RESPONSIBILITY",
  },
  {
    id: 11,
    title: "בירור",
    text: "TERMS_ARBITRATION",
  },
  {
    id: 12,
    title: "קריאת תנאים",
    text: "TERMS_READING",
  },
  {
    id: 13,
    title: "הסכמה לתנאים",
    text: "TERMS_ACCEPTANCE",
  },
  {
    id: 14,
    title: "קשר עם ספקי האפליקציות",
    text: "TERMS_APP_PROVIDERS",
  },
];


export const getEmergencyTermsArray = () => [
  {
    id: 15,
    title: "אזהרה",
    text: "TERMS_EMERGENCY_WARNING",
  },
  {
    id: 16,
    title: "מצב חירום",
    text: "TERMS_EMERGENCY_SITUATION",
  },
  {
    id: 17,
    title: "העברת פרטים",
    text: "TERMS_EMERGENCY_DATA_TRANSFER",
  },
  {
    id: 18,
    title: "אמינות מידע",
    text: "TERMS_EMERGENCY_DATA_ACCURACY",
  },
  {
    id: 19,
    title: "הסכמה",
    text: "TERMS_EMERGENCY_CONSENT",
  },
  {
    id: 20,
    title: "חובת דיווח",
    text: "TERMS_EMERGENCY_REPORTING",
  },
];

export const getAdditionalTermsArray = () => [
  {
    id: 21,
    title: "סכנה לחיי אדם",
    text: "TERMS_ADDITIONAL_LIFE_RISK",
  },
  {
    id: 22,
    title: "פגיעה עצמית או באחר",
    text: "TERMS_ADDITIONAL_SELF_OR_OTHERS_HARM",
  },
  {
    id: 23,
    title: "פגיעה או התעללות",
    text: "TERMS_ADDITIONAL_ABUSE_OR_NEGLECT",
  },
];

export const getRegistrationTermsArray = () => [
  {
    id: 24,
    title: "הרשמה לשירות",
    text: "TERMS_REGISTRATION_ACCOUNT",
  },
  {
    id: 25,
    title: "מידע אישי",
    text: "TERMS_REGISTRATION_PERSONAL_INFO",
  },
  {
    id: 26,
    title: "אישור גיל ומיקום",
    text: "TERMS_REGISTRATION_AGE_LOCATION",
  },
];

export const getAccountSecurityArray = () => [
  {
    id: 27,
    title: "שמירה על סודיות",
    text: "TERMS_ACCOUNT_SECURITY_CONFIDENTIALITY",
  },
];

export const getProhibitedContentArray = () => [
  {
    id: 29,
    title: "תוכן אסור",
    text: "TERMS_PROHIBITED_CONTENT",
  },
  {
    id: 30,
    title: "דואר אלקטרוני לא רצוי",
    text: "TERMS_PROHIBITED_UNWANTED_EMAIL",
  },
  {
    id: 31,
    title: "תוכן שעלול לגרום נזק לצד שלישי",
    text: "TERMS_PROHIBITED_THIRD_PARTY_HARM",
  },
  {
    id: 32,
    title:
      "תוכן שעשוי להוות, לגרום או לעודד פעולה פלילית או להפר כל חוק החל",
    text: "TERMS_PROHIBITED_ILLEGAL_ACTIVITY",
  },
  {
    id: 33,
    title:
      "מידע שמפר או מפר זכויות קניין רוחני של אחרים או זכויות פרטיות או פרסום של אחרים",
    text: "TERMS_PROHIBITED_IP_VIOLATION",
  },
];

export const getAssistanceServiceArray = () => [
  {
    id: 34,
    title: "שירותי עזרה נפשית דחופה",
    text: "TERMS_ASSISTANCE_URGENT_HELP",
  },
  {
    id: 35,
    title: "אינך מחויב בתשלום",
    text: "TERMS_ASSISTANCE_NO_PAYMENT",
  },
  {
    id: 36,
    title: "התשלום עבור שירותים נוספים",
    text: "TERMS_ASSISTANCE_ADDITIONAL_SERVICES",
  },
];

export const getProvidersTermsArray = () => [
  { id: 37, title: "אזהרה", text: "TERMS_PROVIDERS_WARNING" },
  { id: 38, title: "מצב חירום", text: "TERMS_PROVIDERS_EMERGENCY" },
  { id: 39, title: "העברת פרטים", text: "TERMS_PROVIDERS_DATA_TRANSFER" },
  { id: 40, title: "אמינות מידע", text: "TERMS_PROVIDERS_INFORMATION_ACCURACY" },
  { id: 41, title: "הסכמה", text: "TERMS_PROVIDERS_CONSENT" },
];

export const getIntellectualPropertyTermsArray = () => [
  { id: 42, title: "אזהרה", text: "TERMS_IP_WARNING" },
  { id: 43, title: "מצב חירום", text: "TERMS_IP_EMERGENCY" },
];

export const getDoNotsTermsArray = () => [
  { id: 44, title: "אזהרה", text: "TERMS_DONOTS_WARNING" },
  { id: 45, title: "מצב חירום", text: "TERMS_DONOTS_EMERGENCY" },
];

export const getDisclaimerTermsArray = () => [
  { id: 46, title: "כתבי ויתור", text: "TERMS_DISCLAIMER_GENERAL" },
  { id: 47, title: "כתבי ויתור", text: "TERMS_DISCLAIMER_SPECIFIC" },
  { id: 48, title: "כתבי ויתור", text: "TERMS_DISCLAIMER_RESPONSIBILITY" },
];

export const getLiabilityTermsArray = () => [
  { id: 49, title: "כתבי ויתור", text: "TERMS_LIABILITY_GENERAL" },
  { id: 50, title: "כתבי ויתור", text: "TERMS_LIABILITY_LIMITATION" },
  { id: 51, title: "כתבי ויתור", text: "TERMS_LIABILITY_JURISDICTION" },
  { id: 52, title: "כתבי ויתור", text: "TERMS_LIABILITY_PROTECTION" },
];

export const getSupportsTermsArray = () => [
  { id: 53, title: "תנאי תמיכה", text: "TERMS_SUPPORT_GENERAL" },
  { id: 54, title: "תנאי תמיכה", text: "TERMS_SUPPORT_MINIMAL_PERSONAL_INFO" },
  { id: 55, title: "תנאי תמיכה", text: "TERMS_SUPPORT_DATA_STORAGE" },
];

export function getGreeting(): string {
  const currentHour = new Date().getHours();

  if (currentHour >= 5 && currentHour < 12) {
    return "בוקר טוב,";
  } else if (currentHour >= 12 && currentHour < 17) {
    return "צהריים טובים,";
  } else if (currentHour >= 17 && currentHour < 22) {
    return "ערב טוב,";
  } else {
    return "לילה טוב,";
  }
}

export const formatDateTime = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
};

export const formatDateTimeInIsrael = (dateInput: Date | string): string => {
  // Convert input to a Date object if it's a string
  const date = new Date(dateInput);

  // Use Intl.DateTimeFormat to get the date in Israel time
  const israelTime = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jerusalem", // The IANA time zone identifier for Israel
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // Use 24-hour format
  }).format(date);

  // Extract the components from the formatted Israel time
  const [formattedDate, formattedTime] = israelTime.split(", ");
  const [day, month, year] = formattedDate.split("/");
  const [hours, minutes] = formattedTime.split(":");

  // Format to desired output (YYYY-MM-DDTHH:mm:ssZ)
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export function findNextUnansweredQuestion(
  array: TQuestion[],
  nextQuestionId: number
): TQuestion | null {
  // Find the object with the current nextQuestionId
  let currentQuestion = array.find(
    (question) => question.Id === nextQuestionId
  );
  // If the object is found
  if (currentQuestion) {
    // If the answer is null, return the current question
    if (!currentQuestion.Answer) {
      return currentQuestion;
    } else {
      // If the answer is not null, recursively find the next question using its NextQuestionId
      return findNextUnansweredQuestion(array, currentQuestion.NextQuestionId);
    }
  }

  // If the question is not found, return null
  return null;
}

export function parseTypingString(
  typingString: string
): { userId: string; isTyping: boolean } | null {
  // Use a regular expression to capture userId and isTyping from the string
  const regex = /TYPING uid(\d+) isTyping(true|false)/;
  const match = typingString.match(regex);

  // If the string matches the expected format, extract the userId and isTyping values
  if (match) {
    const userId = match[1]; // Extract userId
    const isTyping = match[2] === "true"; // Convert 'true'/'false' to boolean
    return { userId: userId, isTyping: isTyping };
  } else {
    // Return null if the string does not match the expected format
    return null;
  }
}

export const toggleMuteMic = (
  mediaStream: MediaStream | undefined,
  setIsMicMuted: (a: boolean) => void
) => {
  if (mediaStream) {
    const audioTrack = mediaStream.getAudioTracks()[0];
    if (audioTrack) {
      audioTrack.enabled = !audioTrack.enabled;
      setIsMicMuted(!audioTrack.enabled); // Update state to reflect mute/unmute
    }
  }
};

export const toggleVideo = (
  mediaStream: MediaStream | undefined,
  setIsVideoEnabled: Dispatch<SetStateAction<boolean>>
) => {
  if (mediaStream) {
    const videoTracks = mediaStream.getVideoTracks();
    if (videoTracks.length > 0) {
      // Toggle track.enabled (do not stop the track)
      const isEnabled = videoTracks[0].enabled;
      videoTracks.forEach((track) => {
        if (track.readyState === "live") {
          track.enabled = !track.enabled;
        }
      });
      setIsVideoEnabled(!isEnabled);
    }
  }
};

export function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
export function checkValidMail(email: string) {
  return /^\S+@\S+\.\S+$/.test(email) ? true : false;
}

export const allowedTypes = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "image/png",
  "image/jpeg",
  "image/gif",
];
export const maxFileSizeMB = 10;

export function normalizeDashes(text: string) {
  return text.replace(/[–—]/g, '-');
}